import { type UseModalState, useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { UpdateChartingCredentialsContainer } from "@src/appV2/redesign/Charting/UpdateChartingCredentialsContainer";
import { type ChartingCredential } from "@src/appV2/Shifts/Shift/useGetChartingCredentials";
import { useEffect } from "react";

import { YourChartingLoginBottomSheet } from "./YourChartingLoginBottomSheet";

export interface YourChartingLoginBottomSheetContainerProps {
  modalState: UseModalState;
  shiftId?: string;
  workplaceId: string;
  workerId: string;
  chartingCredentials?: ChartingCredential;
  onClose?: () => void;
}

export function YourChartingLoginBottomSheetContainer(
  props: YourChartingLoginBottomSheetContainerProps
) {
  const { modalState, shiftId, workplaceId, workerId, chartingCredentials, onClose } = props;

  const updateCredentialsModalState = useModalState();

  const logMetadata = {
    shiftId,
    workplaceId,
    workerId,
  };

  // If we don't have credentials, open the update credentials modal instead
  useEffect(() => {
    if (modalState.modalIsOpen && !isDefined(chartingCredentials)) {
      modalState.closeModal();
      updateCredentialsModalState.openModal();
    }
  }, [chartingCredentials, modalState, updateCredentialsModalState]);

  const handleGotIt = () => {
    logEvent(APP_V2_USER_EVENTS.YOUR_CHARTING_LOGIN_GOT_IT, logMetadata);
  };

  const handleUpdateChartingLogin = () => {
    logEvent(APP_V2_USER_EVENTS.YOUR_CHARTING_LOGIN_UPDATE, logMetadata);
    updateCredentialsModalState.openModal();
  };

  return (
    <>
      <YourChartingLoginBottomSheet
        modalState={modalState}
        chartingCredentials={chartingCredentials}
        onGotIt={handleGotIt}
        onUpdateChartingLogin={handleUpdateChartingLogin}
        onClose={onClose}
      />

      <UpdateChartingCredentialsContainer
        modalState={updateCredentialsModalState}
        shiftId={shiftId}
        workplaceId={workplaceId}
        workerId={workerId}
        chartingCredentials={chartingCredentials}
      />
    </>
  );
}
